<template>
  <div class="order-pages">
    <div class="page-head">
      <div class="mains-content">
        <div class="tops-between">
          <div class="tops-title">
            <p>修护档案</p>
          </div>
        </div>
        <div class="member-content-box">
          <div class="member-header">
            <el-input
              placeholder="请输入手机号"
              v-model="keyword"
              clearable
              @clear="removeDoQuery"
              class="input-with-select"
              prefix-icon="el-icon-search"
            />
            <el-button type="primary" @click="searchDoQuery" style="height: 48px;">搜索</el-button>
          </div>
        </div>
        <el-table :data="list" max-height="468px">
          <el-table-column
            :prop="index"
            :align="item.align"
            :label="item.label"
            :width="item.width"
            :min-width="item.minWidth"
            :show-overflow-tooltip="false"
            v-for="(item,index) in columns"
            :key="index"
          >
            <template slot-scope="scope">
              <div>{{Boolean(item.formatDay)?formatDay(scope.row[index]):scope.row[index]}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="amt" label="操作" align="center" width="180" fixed="right">
            <template slot-scope="scope">
              <el-link type="primary" @click="handleDetail(scope.row)">档案列表</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="mains-bottom">
        <div class="back el-icon-back" @click="back"></div>
        <!-- <div class="btns">
          <el-button class="btn first-btn" @click="gotoRepair">新增修护</el-button>
          <el-button class="btn last-btn" type="primary" @click="addCheckIn">修护登记</el-button>
        </div>-->
      </div>
    </div>
    <handle ref="handleForm" @change="handleSave"></handle>
    <handle-edit ref="handleEditForm" @change="editChange"></handle-edit>
    <repair-check-in ref="checkInForm" @change="checkInSave"></repair-check-in>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import member from "../../components/member";
import config from "./config/columnsLast";
import handle from "./handle";
import handleEdit from "./handle-edit";
import repairCheckIn from "./repairCheckIn";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { member, handle, handleEdit, repairCheckIn },
  data() {
    return {
      columns: config.columns,
      totalAmount: 0,
      form: {
        memberId: ""
      },
      url: this.$url.repairDocument.repairCategoryListByMember,
      list: [],
      repairList: [
        {
          id: "a",
          name: "甲沟炎",
          type: "name",
          show: true
        },
        {
          id: "b",
          name: "灰指甲",
          type: "name",
          show: false
        },
        {
          id: "c",
          name: "血泡刺",
          type: "num",
          show: false
        },
        {
          id: "d",
          name: "肉刺",
          type: "num",
          show: false
        }
      ],
      keyword: "",
      query: {
        memberId: "",
        optStaffId: ""
      },
      height: this.$store.getters.MainHeight
    };
  },

  created() {
    this.getList();
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("payMobile"))) {
      let arr = JSON.parse(localStorage.getItem("payMobile"));
      if (arr.path == this.$route.path) {
        let rows = JSON.parse(localStorage.getItem("repairEditRows"));
        this.$refs["checkInForm"].$emit("set", {
          id: rows.id,
          repairStatus: rows.repairStatus
        });
      }
    }
  },
  methods: {
    editChange() {
      /*
                TODO 不知道干啥用的，淦！
            */
    },
    addCheckIn() {
      //this.repairForm
      this.$refs["handleEditForm"].$emit("set", {
        categoryId: this.query.categoryId
      });
    },
    gotoRepair() {
      this.$router.push("/collectMoney/paperRepair");
    },
    back() {
      this.$router.push("/collectMoney");
    },
    gotoCenter() {
      this.$router.push(`/collectMoney/center`);
    },
    handleChangeList(item, index) {
      for (let i in this.repairList) {
        this.repairList[i].show = false;
      }
      this.query.categoryId = item.id;
      this.$set(this.repairList[index], "show", true);
    },
    removeDoQuery() {
      //   this.query.start = 1;
      //   this.list = [];
      //   this.getList();
    },
    searchDoQuery() {
      //   this.query.start = 1;
      //   this.list = [];
      //   this.getList();
      if (this.query.keyword != "") {
        this.$api
          .get(this.$url.member.search, {
            keyword: this.keyword,
            needIntegralFlag: true
          })
          .then(res => {
            if (res) {
              this.query.memberId = res.memberList[0].id;
              this.getListData();
            } else {
              this.list = res;
            }
          })
          .catch(error => {});
      } else {
        this.$message.warning("请输入客户手机号、编号或姓名");
      }
    },
    getListData(id) {
      this.$api
        .post(this.$url.repairDocument.repairCategoryListByMember, this.query)
        .then(res => {
          if (res) {
            this.list = res;
          }
        });
    },
    memberChange(value) {
      this.form.memberId = value;
      this.query.memberId = value;
      this.query.start = 1;
      this.getList();
    },
    handleDetail(row, index) {
      if (row.categoryId) {
        this.$router.push({
          name: "/collectMoney/paperRepair/edit",
          query: {
            memberId: this.query.memberId,
            categoryId: row.categoryId
          }
        });
      } else {
        this.$router.push({
          name: "/collectMoney/paperRepair/oldEdit",
          params: {
            memberId: this.query.memberId,
            categoryId: row.categoryId
          }
        });
      }
      //   if (row.repairStatus == "handle") {
      //     this.$refs["handleForm"].$emit("set", {
      //       id: row.id,
      //       repairStatus: row.repairStatus
      //     });
      //   } else {
      //     this.$refs["checkInForm"].$emit("set", {
      //       id: row.id,
      //       repairStatus: row.repairStatus
      //     });
      //     localStorage.setItem("repairEditRows", JSON.stringify(row));
      //   }
    },
    handleSave(org) {
      console.log("org: ", org);
    },
    checkInSave(org) {
      if (org) {
        this.getList();
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
.member-content-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-bottom: 2px solid @borderColor;
}
.repair-title {
  display: flex;
  flex-wrap: wrap;
  padding: 15px 25px;
  /deep/ .el-row {
    width: 100%;
    &:hover {
      cursor: pointer;
    }
    .el-col {
      width: 133px;
      height: 48px;
      margin-right: 10px;
      border-radius: 5px;

      border: 1px solid #979797;
      &:last-child {
        margin-right: 0;
      }
      .card-div {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .card-msg {
        .img {
          width: 27px;
          height: 44px;
        }
      }
    }
  }
  /deep/ .el-row {
    .active {
      background: rgba(51, 111, 237, 0.2);
      border: 1px solid #4e89f8;
      p {
        font-weight: 500;
        color: #4e89f8;
      }
    }
  }
}
.member-header {
  width: 556px;
  height: 88px;
  display: flex;
  align-items: center;
  padding: 0 26px;
  background-color: #fff;

  .header-box {
    width: 100%;
    display: flex;
    box-sizing: border-box;
  }
  .input-with-select {
    width: 100%;
    height: 48px;
    margin-right: 15px;
    /deep/ .el-input__inner {
      height: 48px;
      line-height: 48px;
      padding-left: 35px;
      //   background: #e1e1e1;
    }
    /deep/ .el-input__clear {
      font-size: 22px;
      line-height: 48px;
    }
    /deep/ .el-input__prefix {
      color: @blue;
      font-size: 24px;
      margin-right: 10px;
      .el-input__icon {
        line-height: 48px;
      }
    }
  }
}

.page-head {
  height: 100%;
}
.mains-bottom {
  .back {
    // position: absolute;
    // left: 26px;
  }
  width: calc(100% - 30px);
  position: absolute;
  background-color: #fff;
  height: 62px;
  margin-top: 10px;
  padding: 0 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  bottom: 15px;
  box-sizing: border-box;
  .last-btn {
    margin-left: 22px;
  }
}
.mains-content {
  height: calc(100% - 72px);
  .tops-between {
    background: #fff;
    display: flex;
    justify-content: space-between;
    padding: 0 25px;
    align-items: center;
    // border-bottom: 2px solid @borderColor;
  }
  .tops-title {
    width: 100%;
    box-sizing: border-box;

    p {
      font-size: 18px;
      font-weight: 500;
      height: 60px;
      line-height: 60px;
      span {
        color: @blue;
      }
    }
    .add-btns {
      width: 100px;
      height: 32px;
    }
  }
  .member-content-box {
    // padding: 0 25px;
    margin-top: 10px;
  }
  .member-header {
    // background: #fff;
    // height: 56px;
    // padding: 0 25px;
    // display: flex;
    // align-items: center;
    // border-bottom: 2px solid @borderColor;
  }
}
</style>